import { http } from "@/utils/http"

export default class EmailTemplateFetchApi {
    static async list({ includeArchived = false } = {}) {
        const response = await http.get("/email-templates", {
            params: { includeArchived: includeArchived ? "1" : "0" },
        })
        return response.data.result
    }

    static async get(templateKey) {
        const response = await http.get(`/email-templates/${encodeURIComponent(templateKey)}`)
        return response.data.result
    }

    static async listStarters() {
        const response = await http.get("/email-templates/starters")
        return response.data.result
    }

    static async listFieldCatalog() {
        const response = await http.get("/email-templates/fields/catalog")
        return response.data.result
    }

    static async create(payload) {
        const response = await http.post("/email-templates", payload)
        return response.data.result
    }

    static async updateMetadata(templateKey, payload) {
        const response = await http.patch(
            `/email-templates/${encodeURIComponent(templateKey)}`,
            payload
        )
        return response.data.result
    }

    static async saveDraft(templateKey, payload) {
        const response = await http.patch(
            `/email-templates/${encodeURIComponent(templateKey)}/draft`,
            payload
        )
        return response.data.result
    }

    static async sendTest(templateKey, payload) {
        const response = await http.post(
            `/email-templates/${encodeURIComponent(templateKey)}/test`,
            payload
        )
        return response.data.result
    }

    static async publish(templateKey, payload) {
        const response = await http.post(
            `/email-templates/${encodeURIComponent(templateKey)}/publish`,
            payload
        )
        return response.data.result
    }

    static async listVersions(templateKey) {
        const response = await http.get(`/email-templates/${encodeURIComponent(templateKey)}/versions`)
        return response.data.result
    }

    static async getVersion(templateKey, version) {
        const response = await http.get(
            `/email-templates/${encodeURIComponent(templateKey)}/versions/${version}`
        )
        return response.data.result
    }

    static async rollback(templateKey, payload) {
        const response = await http.post(
            `/email-templates/${encodeURIComponent(templateKey)}/rollback`,
            payload
        )
        return response.data.result
    }

    static async archive(templateKey) {
        const response = await http.post(
            `/email-templates/${encodeURIComponent(templateKey)}/archive`
        )
        return response.data.result
    }

    static async restore(templateKey) {
        const response = await http.post(
            `/email-templates/${encodeURIComponent(templateKey)}/restore`
        )
        return response.data.result
    }
}
